import React from 'react';
import SidebarDropDownOption from '../../../../components/SidebarDropDownOption';
import { Link } from 'react-router-dom';
import {useSelector } from 'react-redux';
import routes from "../../../../Routes/routes";
import SubMenu from "../../../../components/Sidebar/SubMenu";
import {IconsSideBar} from "../Functionality/IconsSideBar";
import {STATUS_MODEL} from "../../../../enums/statusEnum";
import CommonTabsApp from "../Functionality/CommonTabsApp";

const ProviderTabs = ({ isMenuOpen }) => {
    const props = CommonTabsApp();
    const { openMenu, changeStyle, setChangeStyle, isHovering, setIsHovering,
        handleMenuToggle, handleMenuItemClick} = props;
    const { user } = useSelector((state) => state.authenticatioauthennSlice);



    const menuItems = [
        {
            name: 'employees',
            url:routes.suppliers.employees,
            label: 'employees',
            onlyName: true,
            icon: IconsSideBar.icEmployees,
            isHovering: 4,
            hasPermission: '',

        },
        {
            name: 'vehicles',
            url: routes.suppliers.vehicleFleet,
            label: 'vehicle_fleet',
            onlyName: true,
            icon: IconsSideBar.icVehicleFleet,
            isHovering: 5,
            hasPermission: '',
        },
        {
            name: 'orders',
            url: routes.suppliers.orders,
            label: 'purchase_orders',
            onlyName: true,
            icon: IconsSideBar.icSupplier,
            isHovering: 7,
            hasPermission:'',
            hide: user?.data?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT
        },
        {
            name: 'announcements',
            url: routes.suppliers.announcements,
            label: 'announcements',
            onlyName: true,
            icon: IconsSideBar.icAnnouncements,
            isHovering: 28,
            hasPermission: '',
            hide: user?.data?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT
        },
        {
            name: 'profile',
            url:  routes.suppliers.profile,
            label: 'profile',
            onlyName: true,
            icon: IconsSideBar.icProfile,
            isHovering: 21,
            hasPermission: '',
        },
        {
            name: 'transportRequest',
            url: routes.suppliers.transportRequest,
            label: 'transport_request',
            onlyName: true,
            icon: IconsSideBar.icTransportRequest,
            isHovering: 35,
            hasPermission: '',
            hide: user?.data?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT

        },
        {
            name: 'foodie_dining',
            url: routes.suppliers.foodie,
            label: 'foodie_dining',
            onlyName: true,
            icon: IconsSideBar.icCafeteria,
            isHovering: 36,
            hasPermission: '',
            hide: user?.data?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT

        },
        {
            name: 'companyDocumentation',
            url: routes.suppliers.companyDocumentation,
            label: 'company_documentation',
            onlyName: true,
            icon: IconsSideBar.icCompanyDocumentation,
            isHovering: 8,
            hasPermission: true
        },
    ];

    return (<>
        <ul className={isMenuOpen ? 'largeMenu' : 'shortMenu'}>
            {menuItems
                .filter((item) => !item.hide)
                .map((item, index) => (
                <SubMenu
                    key={index}
                    name={item.name}
                    isMenuOpen={isMenuOpen}
                    url={item.url}
                    isHovering={isHovering}
                    numHovering={item.isHovering}
                    label={item.label}
                    menuId={`menu-${index}`}
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    setChangeStyle={setChangeStyle}
                    onClick={() => handleMenuItemClick(item.name)}
                    changeStyle={changeStyle}
                    Icon={item.icon}
                    onLeave={() => setIsHovering(0)}
                    onHover={() => setIsHovering(item.isHovering)}
                    onlyName={item.onlyName}
                />
            ))}
            <Link to='#'>
                <li className={isMenuOpen ? 'profile_li' : 'profile_li_col'}>
                    <SidebarDropDownOption
                        changestyle={changeStyle}
                        hovereffect={isHovering}
                        isMenuOpen={isMenuOpen}
                        menutop={false}
                    />
                </li>
            </Link>
        </ul>
        <div className='border-bottom border-white'/>
        </>
    );
};

export default ProviderTabs;

